<template>
    <v-container class="pa-0" fluid>
        <v-row justify="center">
            <v-col cols="12" md="8" lg="7">
                <v-card class="mb-4" elevation="2">
                    <v-card-title>
                        <h2 class="text-h5 font-weight-bold mb-2">Accesorios destacados</h2>
                    </v-card-title>
                    <v-card-text>
                        <!-- <v-list two-line> -->
                        <draggable
                            v-model="listaAceesorios"
                            tag="div"
                            :animation="200"
                            group="description"
                            :disabled="false"
                            ghost-class="ghost"
                            @start="drag = true"
                            @end="drag = false"
                        >
                            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                <v-list-item
                                    v-for="(item, index) in listaAceesorios"
                                    :key="item.idproducto"
                                    class="mb-4 cursor-move"
                                    style="border-radius: 10px"
                                >
                                    <v-list-item-avatar size="35">
                                        <v-chip color="primary">{{ index + 1 }}</v-chip>
                                    </v-list-item-avatar>

                                    <v-list-item-avatar tile size="50" class="mx-3">
                                        <v-img :src="assetAWS('monturas/' + item.imagen)" :alt="item.nombre" />
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title class="font-weight-bold">
                                            {{ item.nombre }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            <span class="text-muted">Código:</span>
                                            {{ item.idproducto.toString().padStart(6, '0') }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>

                                    <v-list-item-action>
                                        <v-btn icon color="error" @click="eliminar(item)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </transition-group>
                        </draggable>
                        <!-- </v-list> -->
                    </v-card-text>
                </v-card>

                <v-card class="mb-4" elevation="2">
                    <v-card-title>
                        <h2 class="text-h5 font-weight-bold mb-2">Agregar accesorio</h2>
                    </v-card-title>
                    <v-card-text>
                        <v-text-field
                            v-model="query"
                            placeholder="Buscar accesorio..."
                            @input="buscarAccesorios"
                            dense
                            outlined
                            hide-details
                            class="mb-2"
                            clearable
                        />
                        <v-list v-if="resultados.length" class="mb-2">
                            <v-list-item v-for="acc in resultados" :key="acc.idproducto" class="rounded-lg">
                                <v-list-item-avatar tile size="50" class="mx-3">
                                    <v-img :src="assetAWS('monturas/' + acc.imagen)" :alt="acc.nombre" />
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>{{ acc.nombre }}</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <span class="text-muted">Código:</span>
                                        {{ acc.idproducto.toString().padStart(6, '0') }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn icon color="primary" @click="agregar(acc)">
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>

                <v-row class="mb-4">
                    <v-col cols="12" class="text-center d-flex gap-2 justify-center">
                        <v-btn color="secondary" @click="fetchAccesorios" class="font-weight-bold" elevation="1">
                            <v-icon left>mdi-refresh</v-icon>
                            Restablecer
                        </v-btn>
                        <v-btn color="primary" @click="guardar" class="font-weight-bold" elevation="2">
                            <v-icon left>mdi-content-save</v-icon>
                            Guardar cambios
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from '@/plugins/axios';
    import draggable from 'vuedraggable';

    const services = {
        fetchAccesorios() {
            return axios.get('/api/panel/resumen-carrito/accesorios');
        },
        searchAccesorios(query) {
            return axios.get('/api/panel/resumen-carrito/accesorios/search', {
                params: { q: query },
            });
        },
        saveAccesorios(accesorios) {
            return axios.post('/api/panel/resumen-carrito/accesorios', {
                accesorios,
            });
        },
    };

    export default {
        components: { draggable },
        display: 'Transitions',
        data() {
            return {
                listaAceesorios: [],
                query: '',
                resultados: [],
                drag: false,
            };
        },
        created() {
            this.fetchAccesorios();
        },
        methods: {
            async fetchAccesorios() {
                try {
                    const { data } = await services.fetchAccesorios();
                    this.listaAceesorios = data;
                } catch (error) {
                    console.error('Error al cargar accesorios:', error);
                }
            },
            async buscarAccesorios() {
                if (this.query.length < 3) {
                    this.resultados = [];
                    return;
                }

                try {
                    const { data } = await services.searchAccesorios(this.query);
                    this.resultados = data;
                } catch (error) {
                    console.error('Error al buscar accesorios:', error);
                }
            },
            agregar(acc) {
                if (!this.listaAceesorios.find((item) => item.idproducto === acc.idproducto)) {
                    this.listaAceesorios.push({ ...acc });
                }

                this.resultados = [];
                this.query = '';

                this.$toasted.success('Accesorio agregado.');
            },
            eliminar(item) {
                this.listaAceesorios = this.listaAceesorios.filter((i) => i.idproducto !== item.idproducto);
            },
            async guardar() {
                try {
                    const response = await services.saveAccesorios(this.listaAceesorios);
                    this.$toasted.success('Accesorios guardados correctamente.');
                } catch (error) {
                    console.error('Error al guardar accesorios:', error);
                }
            },
        },
    };
</script>

<style scoped>
    .gap-2 {
        gap: 0.5rem;
    }

    .text-muted {
        color: #6c7a89;
        font-size: 0.95em;
        margin-right: 0.25em;
    }

    .v-list-item {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .cursor-move {
        cursor: move;
    }

    .flip-list-move {
        transition: transform 0.5s;
    }

    .no-move {
        transition: transform 0s;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
</style>
